<template>
    <div class="ProtectionProductsClass">
        <img :src="baseUrl+'img/'+img" width="100%" alt="" srcset="">
        <div class="new" v-if="title==''">{{$t('新产品，敬请期待')}}</div>
        
        <div class="description">
            <div class="title">{{title}}</div>
            <div class="text">{{text}}</div>
            <div class="btn" v-if="title!=''">
                <div>{{$t('进一步了解')}}</div>
                <img src="../../public/img/right_more.png" alt="" srcset="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
        }
    },
    props:[
        'title','text','img'
    ]
}
</script>
<style lang="less">
.ProtectionProductsClass{
    width: 100%;
    min-height: 300px;
    background-color: #F5F5F5;
    position: relative;
    margin-top: 20px;
    cursor: pointer;
    .new{
        text-align: center;
        color: #017CA8;
        font-size: 0.7rem;
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .description{
        position: absolute;
        width: 100%;
        left: 10%;
        top: 10%;
        height: 100%;
        .title{
            font-size: 1.5rem;
            color: #444444;
        }
        .text{
            font-size: 0.7rem;
            color: #444444;
            margin-top: 0.4rem;
        }
        
    }
    .btn{
        margin-top: 0.4rem;
        height: 1rem;
        font-size: 0.55rem;
        color: #017CA8;
        // height: 2rem;
        display: flex;
        // width: 6rem;
        width: fit-content;
        padding: 0 20px;
        align-items: center;
        justify-content: center;
        border-radius: 2rem;
        border: 1px solid #017CA8;
        cursor: pointer;
        img{
            height: 0.7rem;
            margin-left: 9px;
        }
    }
}
.ProtectionProductsClass:hover{
    transform: scale(1.05);
    transition: 0.1s all linear;
}
</style>

<i18n>
{
  "en": {
      "进一步了解":"More about",
      "新产品，敬请期待":"New products, stay tuned"
  },
  "zh": {
      "进一步了解":"进一步了解",
      "新产品，敬请期待":"新产品，敬请期待"
  }
}
</i18n>